import React, { useContext } from 'react'
import { Chevron } from '@superlogica/design-ui'

import AccordionContext from './Accordion.Context'
import * as S from './Accordion.styled'

interface HeadingProps {
  accordionId?: string
  className?: string
  chevron?: Color | boolean
}

const AccordionHeading: React.FC<HeadingProps> = ({
  accordionId,
  className,
  children,
  chevron = 'babar700',
  ...rest
}) => {
  const { isExpanded, toggle } = useContext(AccordionContext)

  return (
    <S.Heading
      id={`heading-${accordionId}`}
      className={className}
      aria-expanded={isExpanded(accordionId)}
      aria-controls={`collapse-${accordionId}`}
      onClick={(e) => {
        accordionId && toggle(e, accordionId)
      }}
      {...rest}
    >
      {children}
      {chevron !== false && (
        <Chevron
          active={isExpanded(accordionId)}
          size={12}
          color={typeof chevron === 'string' ? chevron : 'babar700'}
        />
      )}
    </S.Heading>
  )
}

export default AccordionHeading
